<template>
  <el-dialog
    title="选择一个人员"
    :visible.sync="visible"
    width="660px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.userName"
        placeholder="请输入姓名"
        style="width: 200px"
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        width="50">
        <template slot-scope="{row}">
          <el-radio
            v-model="current.userId"
            :label="row.userId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="姓名"
        min-width="140"
        prop="userName">
      </el-table-column>
      <el-table-column
        label="手机号"
        width="140"
        prop="mobilePhone">
      </el-table-column>
      <el-table-column
        label="身份证"
        width="200"
        prop="idCertNo">
      </el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange">
    </el-pagination>
    <div slot="footer">
      <el-button
        type="info"
        @click="additem">新 增</el-button>
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
    <edit-user-modal
      ref="user"
      :callback="() => { fetchList() }"
    />
  </el-dialog>
</template>
<script>
import EditUserModal from './edit-user-modal.vue'
export default {
  name: 'UserSelectModal',
  components: { EditUserModal },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      list: [],
      totalNum: 0,
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        userName: ''
      },
      current: {}
    }
  },
  methods: {
    additem() {
      this.$refs.user.add()
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.config.pageNum = 1
      this.config.userName = ''
      this.list = []
      this.current = {}
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    add() {
      if (!this.current.userId) {
        this.$message.error('请选择一个操作员')
        return
      }
      this.callback && this.callback(this.current)
      this.toggleModal(false)
    },
    handleCurrentRowChange(row) {
      console.log('handleCurrentRowChange', row)
      this.current = row || {}
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('account/getusers', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch() {
      this.fetchList()
      this.toggleModal(true)
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
